import React, { useState, useEffect } from "react";
import { Box, IconButton, Text, useColorModeValue } from "@chakra-ui/react";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";

const DateChanger = ({ currentInfo, changeDate }) => {
  const [intervalId, setIntervalId] = useState(null);
  const iconColor = useColorModeValue("#4b635e", "#E9A6A6");

  const startChangingDate = (direction) => {
    const interval = setInterval(() => {
      changeDate(direction);
    }, 50); // Change date every 100ms

    setIntervalId(interval);
  };

  const stopChangingDate = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  useEffect(() => {
    return () => {
      // Cleanup interval on component unmount
      stopChangingDate();
    };
    // eslint-disable-next-line
  }, [intervalId]);

  return (
    <Box textAlign="center" my={4}>
      <IconButton
        icon={<ArrowBackIcon color={iconColor} />}
        onClick={() => changeDate(-1)}
        onMouseDown={() => startChangingDate(-1)}
        onMouseUp={stopChangingDate}
        onTouchEnd={stopChangingDate}
        aria-label="Previous Day"
        mr={2}
      />
      <Text
        display="inline"
        fontSize="lg"
        color={iconColor}
        fontFamily="Lilita One, sans-serif"
      >
        {currentInfo ? currentInfo.date : "No data"}
      </Text>
      <IconButton
        icon={<ArrowForwardIcon color={iconColor} />}
        onClick={() => changeDate(1)}
        onMouseDown={() => startChangingDate(1)}
        onMouseUp={stopChangingDate}
        onTouchEnd={stopChangingDate}
        aria-label="Next Day"
        ml={2}
      />
    </Box>
  );
};

export default DateChanger;
